import { Copy, LogOut } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/auth'
import { Avatar, AvatarFallback } from '../ui/avatar'
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '../ui/dropdown-menu'
import { toast } from '../../stores/toast'
import { isSuperAdmin, parseTokenClaims } from '../../lib/authz'
import { logout as serverLogout } from '../../api/auth'

export function UserMenu() {
  const navigate = useNavigate()
  const me = useAuthStore((s) => s.me)
  const token = useAuthStore((s) => s.token)
  const claims = parseTokenClaims(token)
  const displayName = me?.displayName || claims?.name || '已登录用户'
  const isSuper = isSuperAdmin(claims)

  const copyToken = () => {
    if (!token) return
    void navigator.clipboard.writeText(token).then(
      () => toast.success('令牌已复制到剪贴板'),
      () => toast.error('复制失败'),
    )
  }

  const logout = () => {
    // 先吊销服务端 refresh 会话并清本地，再回登录页
    void serverLogout().finally(() => navigate('/login'))
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2 rounded-lg border border-border px-2 py-1.5 text-left transition hover:bg-foreground/[.05]">
        <Avatar>
          <AvatarFallback>{displayName.slice(0, 1).toUpperCase()}</AvatarFallback>
        </Avatar>
        <span className="hidden sm:block">
          <span className="block text-xs leading-4 text-foreground">{displayName}</span>
          <span className="block text-[10px] leading-3 text-muted-foreground">
            {isSuper ? '超级管理员' : (me?.regionCode ?? '区域用户')}
          </span>
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuLabel>{me?.userId ?? claims?.user_id ?? '—'}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={copyToken}>
          <Copy size={13} /> 复制当前令牌
        </DropdownMenuItem>
        <DropdownMenuItem variant="destructive" onSelect={logout}>
          <LogOut size={13} /> 退出登录
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
